export const INTEGRATE_SLACK = {
  id: 'integrateSlack',
  iconClass: 'fab fa-slack text-info',
  title: 'Join Slack',
  body: 'Join our Slack Workspace to begin chatting with instructors and other members.',
  children: true
};
